import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope) {
    var ctrl = Object.create(BaseCtrl);
    ctrl.init = function () {};

    return ctrl.create($scope);
};

fn.$inject = ['$scope'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/controllers/AmaComplexQuoteError.js
// module id = 834
// module chunks = 0